import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import DataInvolvedItem from '../DataInvolvedItem/DataInvolvedItem';
import { DetailsWrapper, LinkButton, StyledDetails } from './DetailsStyles';

const Details = ({ details, dataInvolved }) => {
  const [showDetails, setShowDetails] = useState(false);

  if (!details) {
    return null;
  }

  return (
    <StyledDetails>
      <LinkButton onClick={() => setShowDetails(!showDetails)}>
        {showDetails ? 'Less Details' : 'More Details'}
      </LinkButton>
      {showDetails && (
        <>
          {dataInvolved &&
            dataInvolved.length > 1 &&
            dataInvolved.map((data, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <DataInvolvedItem key={index} data={data} isInList />
            ))}
          <DetailsWrapper dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(details) }} />
        </>
      )}
    </StyledDetails>
  );
};

Details.defaultProps = {
  details: null,
  dataInvolved: [],
};

Details.propTypes = {
  details: PropTypes.string,
  dataInvolved: PropTypes.arrayOf(
    PropTypes.shape({
      RecordSource: PropTypes.string,
      RecordType: PropTypes.string,
      RecordInformation: PropTypes.string,
    }),
  ),
};

export default Details;
